class BundleProduct extends HTMLElement {
	constructor() {
		super();
		this.productId = this.dataset.productId;
		this.select = this.querySelector('select');
		this.addButton = this.querySelector('button');
		this.countEl = this.querySelector('[data-count]');
		this.bundleFull = false;
	}

	connectedCallback() {
		document.addEventListener('bundle:variant-change', this.onVariantChange);
		document.addEventListener('bundle:counts-updated', this.onCountsUpdated);
		if (this.select) this.select.addEventListener('change', this.onSelectChange);
		if (this.addButton) this.addButton.addEventListener('click', this.onAddClick);

		const builder = this.closest('bundle-builder');
		if (builder?.preferredVariant) {
			this.applyPreferredVariant(builder.preferredVariant);
		}

		if (builder?.bundleCounts) {
			this.bundleFull = builder.bundleFull ?? false;
			const count = builder.bundleCounts[this.productId] || 0;
			if (this.countEl) this.countEl.textContent = count || '';
		}

		this.updateButtonState(this.select?.selectedOptions[0]);
	}

	disconnectedCallback() {
		document.removeEventListener('bundle:variant-change', this.onVariantChange);
		document.removeEventListener('bundle:counts-updated', this.onCountsUpdated);
		if (this.select) this.select.removeEventListener('change', this.onSelectChange);
		if (this.addButton) this.addButton.removeEventListener('click', this.onAddClick);
	}

	onSelectChange = () => {
		const selectedOption = this.select.selectedOptions[0];
		if (!selectedOption || selectedOption.value === 'default') {
			this.updateButtonState(selectedOption);
			return;
		}

		this.updateButtonState(selectedOption);

		const variantTitle = selectedOption.textContent?.trim();
		if (!variantTitle) return;

		const sourceScroller = this.closest('.bundle-model-slider__scroller');
		const scrollers = document.querySelectorAll('.bundle-model-slider__scroller');
		const scrollSnapshots = new Map();

		scrollers.forEach((scroller) => {
			if (scroller === sourceScroller) {
				scrollSnapshots.set(scroller, { type: 'source', offsetBefore: this.offsetLeft - scroller.scrollLeft });
			} else {
				scrollSnapshots.set(scroller, { type: 'sibling', scrollLeft: scroller.scrollLeft });
			}
		});

		document.dispatchEvent(
			new CustomEvent('bundle:variant-change', {
				detail: { variantTitle, source: this },
			})
		);

		if (scrollSnapshots.size > 0) {
			requestAnimationFrame(() => {
				scrollSnapshots.forEach((snapshot, scroller) => {
					if (snapshot.type === 'source') {
						scroller.scrollLeft = this.offsetLeft - snapshot.offsetBefore;
					} else {
						scroller.scrollLeft = snapshot.scrollLeft;
					}
				});
			});
		}
	};

	onVariantChange = (event) => {
		const { variantTitle, source } = event.detail;
		if (source === this || !variantTitle) return;
		this.applyPreferredVariant(variantTitle);
	};

	applyPreferredVariant(variantTitle) {
		if (!this.select || !variantTitle) return;

		const option = Array.from(this.select.options).find((opt) =>
			opt.textContent.trim().startsWith(variantTitle)
		);

		if (!option) {
			this.select.value = 'default';
			this.updateButtonState(this.select.selectedOptions[0]);
			return;
		}

		this.select.value = option.value;
		this.updateButtonState(option);
	}

	updateButtonState(option) {
		if (!this.addButton) return;
		const soldOut = option?.disabled;
		const variantId = option?.value;
		const atMaxQty =
			variantId &&
			variantId !== 'default' &&
			this.variantMaxQty?.[variantId] > 0 &&
			(this.variantCounts?.[variantId] || 0) >= this.variantMaxQty[variantId];

		this.addButton.disabled = this.bundleFull || !option || soldOut || option.value === 'default' || atMaxQty;
		this.style.order = soldOut ? '2' : '';
	}

	onCountsUpdated = (event) => {
		this.bundleFull = event.detail.full;
		this.variantCounts = event.detail.variantCounts;
		this.variantMaxQty = event.detail.variantMaxQty;
		const count = event.detail.counts[this.productId] || 0;
		if (this.countEl) this.countEl.textContent = count || '';

		const selectedOption = this.select?.selectedOptions[0];
		if (selectedOption) this.updateButtonState(selectedOption);
	};

	onAddClick = () => {
		const selectedOption = this.select?.selectedOptions[0];
		if (!selectedOption) return;
		const image = this.querySelector('img');
		document.dispatchEvent(
			new CustomEvent('bundle:add', {
				detail: {
					productId: this.productId,
					variantId: selectedOption.value,
					variantTitle: selectedOption.textContent.trim(),
					maxQty: parseInt(selectedOption.dataset.maxQty, 10) || 0,
					productTitle: this.dataset.productTitle,
					modelName: this.dataset.modelName,
					productType: this.dataset.productType,
					image: image?.src,
				},
			})
		);
	};
}

customElements.define('bundle-product', BundleProduct);
